import {
  MerchantSupportPartnershipContentSchema,
  SupportPartnerKeySchema,
} from "@redotech/redo-support-partnerships-common/support-partnership";
import * as z from "zod";

export const getTeamSupportPartnership = {
  name: "getTeamSupportPartnership" as const,
  input: z.object({}),
  output: z.object({
    partnership: z
      .object({
        partnerKey: SupportPartnerKeySchema,
        name: z.string(),
        content: MerchantSupportPartnershipContentSchema,
      })
      .nullable(),
  }),
};
